import { useForm } from "react-hook-form";
import { zodResolver } from "@hookform/resolvers/zod";
import FormContainer from "../../../../../../common/components/form_container";
import DefaultFormInput from "../../../../../../common/components/default_form_input";
import { Dialog, DialogActions, DialogContent, DialogTitle } from "@mui/material";
import { DefaultFormAutocomplete } from "../../../../../../common/components/default_form_autocomplete";
import { CentroCustoDropDown } from "../../../../../../common/domain/models/centro_custo_dropdown";
import { useCallback, useEffect } from "react";
import { LogTipoTabela } from "../../../../../../common/utils/log_tabela_tipo";
import PrimaryButton from "../../../../../../common/components/primary_button";
import { isNotNullOrUndefined } from "../../../../../../common/utils/utils";
import { ControleEstoque } from "../../../../domain/models/controle_estoque_lista";
import { ControleEstoqueForm, controleEstoqueSchema } from "../../../schemas/Controle_Estoque/controle_estoque";


type Props = {
  open: boolean;
  saving: boolean;
  loading: boolean;
  selectedControleEstoque: ControleEstoque | undefined,
  centroCustoLista: CentroCustoDropDown[],
  onClose: () => void;
  onSubmit: (e: ControleEstoqueForm) => void;
  onOpenChangeHistory: (id: number, tabelaTipo: LogTipoTabela) => void;
};

export const ControleEstoqueModal = ({
  open, saving, loading, selectedControleEstoque, centroCustoLista,
  onClose, onSubmit, onOpenChangeHistory
}: Props) => {

  const hookForm = useForm<ControleEstoqueForm>({
    mode: 'onSubmit',
    reValidateMode: 'onSubmit',
    resolver: zodResolver(controleEstoqueSchema),
  });

  useEffect(() => {
    if (open) {
      hookForm.reset();
      if (selectedControleEstoque) {
        hookForm.setValue("IdCentroCusto", selectedControleEstoque.IdCentroCusto);
        hookForm.setValue("IdControleEstoque", selectedControleEstoque.IdControleEstoque);
        hookForm.setValue("Descricao", selectedControleEstoque.Descricao);

      }
    } else {
      hookForm.reset();
    }
  }, [hookForm, open, selectedControleEstoque]);

  const handleChangeHistory = useCallback(() => {
    if (selectedControleEstoque) {
      onOpenChangeHistory(selectedControleEstoque.IdControleEstoque, LogTipoTabela.CONTROLE_ESTOQUE);
    }
  }, [selectedControleEstoque, onOpenChangeHistory]);

  return (
    <Dialog
      open={open}
      maxWidth="lg"
      fullWidth
      PaperProps={{
        component: 'form',
        onSubmit: hookForm.handleSubmit(onSubmit)
      }}
      sx={{ "& .MuiDialog-paper": { maxWidth: "1200px", width: "100%" } }}
    >
      <DialogTitle>
        Entrada de Produtos
      </DialogTitle>

      <DialogContent>
        <FormContainer title={"Cadastrar/Editar"} arrangement="fullRow">
          <div className="flex flex-col gap-y-4 w-full pt-2">

            <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
              <DefaultFormAutocomplete
                name='IdCentroCusto'
                label='Centro de Custo'
                newButtonLabel='Novo'
                getOptionLabel={(x) => x.title}
                getOptionKey={(x) => x.id}
                options={centroCustoLista}
                reactHookForm={hookForm}
                required={true}
                onNew={() => { }}
              />
              <DefaultFormInput
                name="Descricao"
                label="Descrição"
                required={true}
                reactHookForm={hookForm}
              />
            </div>
          </div>
        </FormContainer>
      </DialogContent>

      <DialogActions>
        <div className="w-full h-full items-center justify-between flex p-4 gap-4">
          <div>
            {
              isNotNullOrUndefined(selectedControleEstoque) &&
              <PrimaryButton
                buttonColor="yellow"
                onClick={handleChangeHistory}>
                <span className="text-xs">
                  Historico de alterações
                </span>
              </PrimaryButton>
            }
          </div>

          <div className="flex flex-row gap-2">
            <div className="p-2 hover:bg-hover-light-gray cursor-pointer dark:hover:bg-border-dark-gray rounded-[4px] font-semibold">
              <h1
                className="text-sm text-black dark:text-white"
                onClick={onClose}>
                Cancelar
              </h1>
            </div>

            <div className="w-[120px]">
              {saving ? (
                <PrimaryButton
                  buttonColor="primary-green">
                  Salvando...
                </PrimaryButton>
              ) : (
                <PrimaryButton
                  type="submit"
                  buttonColor="primary-green">
                  Salvar
                </PrimaryButton>
              )}
            </div>
          </div>
        </div>
      </DialogActions>
    </Dialog>
  );
}